(function ($) {
  Drupal.behaviors.discover_more = {
    attach: function (context, settings) {
      // discover more
      if (page_data['catalog-spp-workswith'] !== undefined) {
        var worksWithData = page_data['catalog-spp-workswith'].products;
      }
    }// attach
  };
})(jQuery);
